export enum OAuth2Scopes {
    PROFILE_WRITE = 'profile.write',

    SUBMISSIONS_WRITE = 'submissions.write',

    LISTS_WRITE = 'lists.write',
}
